<template>
  <el-select v-model="value">
    <el-option v-for="item in options" :key="item.id" :value="item.id" :label="item.name"></el-option>
  </el-select>
</template>

<script>
const cardTypeList = [
  {
    id: 1,
    name: "身份证"
  },
  {
    id: 2,
    name: "护照"
  },
  {
    id: 3,
    name: "士官证"
  },
  {
    id: 4,
    name: "港澳台身份证"
  },
];
export default {
  name: 'CardType',
  data() {
    return {
      options: cardTypeList,
      value: ''
    }
  }
}
</script>

<style>

</style>